<template>
  <field-frame :field="field" :show-optional="showOptional">
    <template #default="{ inputId, describedBy, requiredEmpty }">
      <div class="flex items-center gap-1.5">
        <span v-if="field.prefix" class="text-q4cl-muted text-sm">{{ $t(field.prefix) }}</span>
        <input
          :id="inputId"
          type="text"
          class="field-input"
          :inputmode="effectiveInputmode"
          :autocomplete="effectiveAutocomplete"
          :placeholder="placeholder"
          :maxlength="field.maxlength || undefined"
          :readonly="field.readonly === true"
          :aria-required="field.required ? 'true' : 'false'"
          :aria-invalid="requiredEmpty ? 'true' : 'false'"
          :aria-describedby="describedBy"
          v-model="field.value"
          @blur="convertFullWidthToHalfWidth"
          @keydown="blurWithEnterKey"
        />
        <span v-if="field.postfix" class="text-q4cl-muted text-sm">{{ $t(field.postfix) }}</span>
      </div>
    </template>
  </field-frame>
</template>

<script>
import FieldFrame from '@/components/ui/FieldFrame.vue'
/**
 * 旧旧版踏襲 (Q4CL-client_old_version.xml:3225-3229):
 * inputmodeByName は 3 項目のみ。 autocomplete は field.autocomplete をそのまま使う
 * (privacyItems 定義側で autocomplete が設定されているのでそちらを優先)。
 */
const INPUTMODE_BY_NAME = {
  ptPhone: 'tel',
  ptEmail: 'email',
  ptId: 'numeric'
};

export default {
  name: 'TextField',
  components: {
    'field-frame': FieldFrame
  },
  props: {
    field: { type: Object, required: true },
    showOptional: { type: Boolean, default: false }
  },
  setup(props) {
    const i18n = window.i18nStore;

    const effectiveInputmode = Vue.computed(() => {
      if (props.field.inputmode) return props.field.inputmode;
      return INPUTMODE_BY_NAME[props.field.name] || 'text';
    });

    // 旧旧版踏襲: field.autocomplete (privacyItems 等で定義) をそのまま使う。
    // 何もなければブラウザのデフォルト (autocomplete 属性なし) で良い。
    const effectiveAutocomplete = Vue.computed(() => props.field.autocomplete || undefined);

    const placeholder = Vue.computed(() => {
      // 入力例として使う (説明は description で別途表示済み)
      return i18n ? i18n.i18n(props.field.placeholder || '') : (props.field.placeholder || '');
    });

    // 旧版踏襲: inputmode が numeric/decimal のとき blur で全角数字 → 半角に変換
    // (旧 RenderQuestionnaire.vue:878-889)
    function convertFullWidthToHalfWidth() {
      const im = effectiveInputmode.value;
      if ((im === 'numeric' || im === 'decimal') && props.field.value) {
        props.field.value = String(props.field.value)
          .replace(/[０-９]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 0xFEE0))
          .replace(/[．]/g, '.')
          .replace(/[−]/g, '-');
      }
    }

    // Enter でスマホのソフトキーボードを閉じる (暗黙的フォーム送信も防止)
    function blurWithEnterKey(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        if (e.target && typeof e.target.blur === 'function') e.target.blur();
      }
    }

    return { effectiveInputmode, effectiveAutocomplete, placeholder, convertFullWidthToHalfWidth, blurWithEnterKey };
  }
};
</script>
